module.exports = __webpack_public_path__ + "assets/img/2031591928118_.pic_hd.fe548a3f.jpg";